<template>
    <div>
        <div v-if="!is_claimed" class="text-center mb-16">
            {{ owner_text_trans }}
            <a href="javascript:void(0)" @click="claim_company(company_id)" class="tw-btn">
                {{ claim_trans }}
            </a>
            <hr>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        company_id: {
            type: Number,
            required: true
        },
        is_claimed: {
            type: Boolean,
            required: true
        },
        claim_endpoint: {
            type: String,
            required: true
        },
        claim_redirect_link: {
            type: String,
            required: true
        },
        owner_text_trans: {
            type: String,
            required: true
        },
        claim_trans: {
            type: String,
            required: true
        }
    },
    methods: {
        claim_company() {
            let self = this;

            axios.post(self.claim_endpoint, {
                company_id: self.company_id,
            })
                .then(function () {
                    window.location.href = self.claim_redirect_link;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ClaimRestaurant.vue